import type { AppMode, PriceId } from '@iheartjane/types';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import {
  useAddCartProduct,
  useGetQuickCart,
} from '@jane/shared-ecomm/data-access';
import type { Cart } from '@jane/shared/types';

export interface UseQuickCheckoutCartParams {
  appMode: AppMode;
  initialCart: Cart;
  storeId: string | number;
}

export const useQuickCheckoutCart = ({
  appMode,
  initialCart,
  storeId,
}: UseQuickCheckoutCartParams) => {
  const _queryClient = useQueryClient();
  const { data: cart } = useGetQuickCart(
    initialCart.uuid,
    appMode,
    initialCart
  );
  const { mutate, isPending: isAddingTopper } = useAddCartProduct({});

  const addCartTopper = useCallback(
    // eslint-disable-next-line react-hooks/preserve-manual-memoization
    (productId: number, priceId: PriceId, count: number) => {
      mutate({
        app_mode: appMode,
        app_mode_name: appMode,
        cart_uuid: cart.uuid,
        product: {
          product_id: productId,
          price_id: priceId,
          count,
          recommended: false, //what is this for?
        },
        store_id: storeId,
        user_agent: navigator.userAgent,
      });
    },
    [appMode, cart?.uuid, mutate, storeId]
  );

  return {
    cart: cart ?? initialCart,
    addCartTopper,
    isAddingTopper,
  };
};
